module.exports = __webpack_public_path__ + "img/banner-4.9f527fa0.jpg";